import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';

import { formatDecimal, persianDigits } from '@/features/reports/lib/format';
import { fa } from '../i18n/fa';
import ChartCard from './ChartCard';
import { ChartLegend, COLORS, rtlXAxisProps, rtlYAxisProps, chartTooltipStyle } from './chartTheme';
import { persianDisplayText } from '@/lib/persianUi';

export default function HoardingChart({ hoarding }) {
  const rows = hoarding.map((h) => ({
    name: `${persianDisplayText(h.holder, 'فروشنده')}${h.days_held != null ? ` · ${persianDigits(h.days_held)} روز` : ''}`,
    sold: +h.sold_t.toFixed(1),
    warehoused: +h.warehoused_t.toFixed(1),
  }));
  return (
    <ChartCard title={fa.charts.hoarding.title} empty={rows.length === 0}>
      <ResponsiveContainer>
        <BarChart data={rows} margin={{ top: 8, right: 8, left: 16, bottom: 8 }}>
          <CartesianGrid stroke={COLORS.grid} strokeDasharray="3 3" vertical={false} />
          <XAxis dataKey="name" {...rtlXAxisProps} interval={0} angle={-20} textAnchor="end" height={76} />
          <YAxis {...rtlYAxisProps} tickFormatter={(v) => persianDigits(v)} />
          <Tooltip
            contentStyle={chartTooltipStyle}
            formatter={(value, name) => [`${formatDecimal(value, 1)} ${fa.units.t}`, name]}
          />
          <ChartLegend />
          <Bar dataKey="sold" name={fa.charts.hoarding.sold} stackId="a" fill={COLORS.primary} radius={[0, 0, 0, 0]} />
          <Bar dataKey="warehoused" name={fa.charts.hoarding.warehoused} stackId="a" fill={COLORS.amber} />
        </BarChart>
      </ResponsiveContainer>
    </ChartCard>
  );
}
